import type { Action } from 'vuex';
import clientApi from '@/modules/emerging-threats-clients/api';
import type { EmergingThreatsCommonState } from './mutations';

const getEmergingThreatsForOrg: Action<EmergingThreatsCommonState, any> = async (
  { commit },
  orgID,
) => {
  const res = await clientApi.fetchEmergingThreatListWithSupplierResponse(orgID);
  commit('SET_EMERGING_THREATS', res.data);
};

const clearEmergingThreatsStore: Action<EmergingThreatsCommonState, any> = ({ commit }) => {
  commit('CLEAR_STATE');
};

export const actions = {
  getEmergingThreatsForOrg,
  clearEmergingThreatsStore,
};
